// Produto de exemplo pras explicações das regras: o participante mais caro sem
// porcentagem própria (ou o mais caro do cardápio, se nenhum estiver marcado ainda).
export function produtoExemplo(produtos, config) {
  const regras = config.produtos || {};
  const lista = (produtos || []).filter((p) => !p.tamanhos && Number(p.preco) > 0);
  const semPropria = (r) => r?.desconto_max_pct == null || r?.desconto_max_pct === "";
  const doPadrao = lista.filter((p) => regras[p.id]?.participa && semPropria(regras[p.id]));
  const base = doPadrao.length ? doPadrao : lista;
  return base.reduce((maior, p) => (!maior || Number(p.preco) > Number(maior.preco) ? p : maior), null);
}
